export const ProductTourTranslations = {
  START_THE_TOUR: {
    es: 'Hacer el tour',
    en: 'Start the tour',
    eus: 'Erabili',
    cat: 'Fes el tour',
    pt: 'Iniciar o tour'
  },
  SKIP_THE_TOUR: {
    es: 'Después lo veo',
    en: 'Skip the tour',
    eus: 'Ez dut ikusi nahi',
    cat: 'Ometrà el tour',
    pt: 'Pular o tour'
  },
  PREVIOUS: {
    es: 'Anterior',
    en: 'Previous',
    eus: 'Aurrekoa',
    cat: 'Anterior',
    pt: 'Anterior'
  },
  NEXT: {
    es: 'Siguiente',
    en: 'Next',
    eus: 'Hurrengoa',
    cat: 'Hurri',
    pt: 'Próximo'
  },
  FINISH: {
    es: 'Entendido',
    en: 'Understood',
    eus: 'Eskerrik asko',
    cat: 'Molta gras',
    pt: 'Muito obrigado'
  },
  REDO_THE_TOUR_TITLE: {
    es: 'Vuelve a hacer el tour',
    en: 'That is all!',
    eus: 'Eskerrik asko!',
    cat: 'Això és tot!',
    pt: 'Isso é tudo!'
  },
  HERE_YOU_CAN_REDO_THE_TOUR_DESCRIPTION: {
    es: 'Si en algún momento te sientes perdido, haz clic aquí y vuelve a hacer el tour.',
    en: 'If at any time you feel lost, click here and do the tour again.',
    eus: 'Ez datorrenik erabili berriro egin nahi duzun, egin daiteke hemen. Saiatu botoia sakatu eta berriro zurekin zerbait errepikatuko dugu.',
    cat: "Si en qualsevol moment vols fer el tour de nou, pots fer-ho aquí. Només has d'obrir el botó i et explicarem tot de nou.",
    pt: 'Se em qualquer momento você quiser fazer o tour novamente, você pode fazê-lo aqui. Basta abrir o botão e nós explicaremos tudo de novo para você.'
  },
  PROGRESS_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Sigue tu progreso',
    en: 'Follow your progress',
    eus: 'Zure ikastararen progresua jarraitu',
    cat: 'Segueix el vostre progrés',
    pt: 'Siga seu progresso'
  },
  PROGRESS_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Visualiza tu avance en el estudio y mantén el ritmo día a día.',
    en: 'Access your progress and advance with confidence towards the exam.',
    eus: 'Zure ikastararen progresua erabili eta ziur tasunarekin aurrera.',
    cat: "Accedeix al vostre progrés i pugueu avançar amb confiança cap a l'examen.",
    pt: 'Acesse seu progresso e prossiga com confiança para o exame.'
  },
  POSTS_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Noticias',
    en: 'News',
    eus: 'Berriak',
    cat: 'Notícies',
    pt: 'Notícias'
  },
  POSTS_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Entérate de todas las novedades y actualizaciones de tu formación.',
    en: 'Access the news and updates of your formation.',
    eus: 'Zure ikastararen berriak eta eguneraketak erabili.',
    cat: 'Accedeix a les notícies i actualitzacions de la teva formació.',
    pt: 'Acesse as notícias e atualizações da sua formação.'
  },
  RANKINGS_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Rankings',
    en: 'Rankings',
    eus: 'Errendimenduak',
    cat: 'Classificació',
    pt: 'Classificações'
  },
  RANKINGS_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Gana puntos por estudiar y sube posiciones en el ranking.',
    en: 'Gain points by studying and move up positions in the rankings.',
    eus: 'Eraginkizunak lortu eta errendimenduak gehitu.',
    cat: 'Guanyeu punts per estudiar i pugueu pujar posicions en el rànquing.',
    pt: 'Ganhe pontos estudando e suba posições no ranking.'
  },
  QUIZ_MODE_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Practica con los tests',
    en: 'Practice with the tests',
    eus: 'Erabili testuak erabiltzeko',
    cat: 'Practica amb els tests',
    pt: 'Pratique com os testes'
  },
  QUIZ_MODE_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Pon a prueba lo que has aprendido haciendo los tests.',
    en: 'Test your knowledge by doing the quizzes.',
    eus: 'Zure ezagutzak frogatu testak eginez.',
    cat: 'Prova el teu coneixement fent els tests.',
    pt: 'Teste seu conhecimento fazendo os testes.'
  },
  LIVE_CLASSES_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Clases en directo',
    en: 'Live classes',
    eus: 'Gaiak',
    cat: 'Esdeveniments',
    pt: 'Aulas ao vivo'
  },
  LIVE_CLASSES_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Reserva tu plaza en las próximas clases en directo con tus profes.',
    en: 'Reserve your place in the next live classes with your teachers.',
    eus: 'Zure profesorekin ezkutatutako gaiak erreserbatu.',
    cat: 'Reserva el teu lloc en les properes classes en directe amb els teus professors.',
    pt: 'Reserve seu lugar nas próximas aulas ao vivo com seus professores.'
  },
  EXAM_GROUPS_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Próximas convocatorias',
    en: 'Next exams',
    eus: 'Hurrengo eztabaidak',
    cat: 'Proximes convocatòries',
    pt: 'Próximas convocatórias'
  },
  EXAM_GROUPS_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Añade tus convocatorias para no perderte ninguna actualización.',
    en: 'Add your exams to keep track of your progress.',
    eus: 'Eztabaidak gehitu eta zure progresua jarraitu.',
    cat: 'Afegeix les teves convocatòries per mantenir-te al dia.',
    pt: 'Adicione suas convocatórias para não perder nenhuma atualização.'
  },
  SUBSCRIPTIONS_WIDGET_PRODUCT_TOUR_TITLE: {
    es: 'Accede a tus cursos',
    en: 'Access your courses',
    eus: 'Kursuak erabili',
    cat: 'Accedeix als teus cursos',
    pt: 'Acesse seus cursos'
  },
  SUBSCRIPTIONS_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Accede rápidamente a tus cursos y retoma donde lo dejaste.',
    en: 'Access your courses quickly and resume where you left off.',
    eus: 'Kursuak erabili eta errepikatuko duzu.',
    cat: 'Accedeix als teus cursos ràpidament i continua on ho deixàs.',
    pt: 'Acesse seus cursos rapidamente e retome onde parou.'
  },
  DO_THE_TOUR: {
    es: 'Hacer el tour',
    en: 'Do the tour',
    eus: 'Erabili',
    cat: 'Fes el tour',
    pt: 'Iniciar o tour'
  },
  THERE_A_TOUR_IN_THIS_PAGE: {
    es: 'Hay un tour en esta página, pulsa en el botón para verlo.',
    en: 'There is a tour in this page, click the button to see it.',
    eus: 'Orrialde honetan tour bat dago, sakatu botoia ikusi nahi duzun.',
    cat: 'Hi ha un tour en aquesta pàgina, fes clic en el botó per veure-ho.',
    pt: 'Há um tour nesta página, clique no botão para ver.'
  },
  PLANIFICATION_WIDGET_PRODUCT_TOUR_TITLE: {
    es: '¡Te ayudamos a organizarte!',
    en: 'We help you organize yourself!',
    eus: 'Zure zerbitzua erabiltzeko laguntza',
    cat: 'Et ajudem a organitzar-te!',
    pt: 'Nós ajudamos você a organizar-se!'
  },
  PLANIFICATION_WIDGET_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Sigue tu plan de estudio cada día y avanza con confianza hacia el examen.',
    en: 'Follow your study plan every day and advance with confidence towards the exam.',
    eus: 'Eskatu zure ikastetxeko plan egin den bakoitzean eta ziur tasunarekin aurrera.',
    cat: "Segueix el teu pla d'estudis cada dia i avança amb confiança cap a l'examen.",
    pt: 'Siga seu plano de estudos todos os dias e progrese com confiança para o exame.'
  },
  COURSE_PRODUCT_TOUR_WELCOME_TITLE: {
    es: 'Conoce el nuevo diseño de las lecciones',
    en: 'Discover the new design of the lessons',
    eus: 'Ikasi ikasgaien diseinu berriari buruz',
    cat: 'Coneix el nou disseny de les lliçons',
    pt: 'Descubra o novo design das lições'
  },
  COURSE_PRODUCT_TOUR_WELCOME_DESCRIPTION: {
    es: 'Hemos hecho cambios para que puedas estudiar de forma más fácil y eficiente. ¡Haz el tour y descubre las novedades!',
    en: 'We have made changes to make it easier and more efficient for you to study. Do the tour and discover the new features!',
    eus: 'Aldaketak egin ditugu errazago eta eraginkorrago ikas dezazun. Egin bira eta ezagutu zer berri!',
    cat: 'Hem fet canvis perquè puguis estudiar de manera més fàcil i eficient. Fes el tour i descobreix les novetats!',
    pt: 'Fizemos alterações para tornar mais fácil e eficiente para você estudar. Faça o tour e descubra as novas funcionalidades!'
  },
  LESSONS_TAB_PRODUCT_TOUR_TITLE: {
    es: 'Lecciones del curso',
    en: 'Course lessons',
    eus: 'Kursu ikasgaiak',
    cat: 'Leccions del curs',
    pt: 'Lições do curso'
  },
  LESSONS_TAB_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Aquí verás el temario completo de tu curso, organizado y listo para que avances a tu ritmo.',
    en: 'Here you will see the complete syllabus of your course, organized and ready for you to advance at your own pace.',
    eus: 'Kursuaren temarioa ikasi duzun orrialdean, zuzentuta eta zure ikastetxeko plan erabilera egokitzen duena.',
    cat: 'Aquí veureu el temari complet del curs, ordenat i llest per a que progresseu a vostre ritme.',
    pt: 'Aqui verá o tema completo do curso, organizado e pronto para que prossiga a seu ritmo.'
  },
  FIRST_STEPS_PRODUCT_TOUR_TITLE: {
    es: 'Empieza por aquí',
    en: 'Start here',
    eus: 'Hemen hasi',
    cat: 'Comença aquí',
    pt: 'Comece aqui'
  },
  FIRST_STEPS_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Completa estos primeros pasos para dejar listo tu campus y comenzar a tope.',
    en: 'Complete these first steps to leave your campus ready and start with everything.',
    eus: 'Hemen hasi eta zure ikastararen ezagutza guztia erabili.',
    cat: 'Comença aquí i accedeix a tot el que necessites.',
    pt: 'Comece aqui e acesse tudo o que você precisa.'
  },
  SECTION_TRACKING_SELECTOR_PRODUCT_TOUR_TITLE: {
    es: 'Organiza tu estudio',
    en: 'Organize your study',
    eus: 'Eskatutako zure ikastetxeko plan',
    cat: 'Organitza el teu estudi',
    pt: 'Organize seu estudo'
  },
  SECTION_TRACKING_SELECTOR_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Indica el estado de cada tema para saber cómo vienes con el estudio.',
    en: 'Indicate the status of each topic to know how you are doing with your study.',
    eus: 'Eztabaidaren informazioa zure konbokoatik lortu.',
    cat: "Indica l'estat de cada tema per saber com vaig amb l'estudi.",
    pt: 'Indique o status de cada tema para saber como está acompanhando o seu estudo.'
  },
  SECTION_TRACKING_FILTER_PRODUCT_TOUR_TITLE: {
    es: 'Sigue tu progreso',
    en: 'Follow your progress',
    eus: 'Eskatutako zure ikastetxeko plan',
    cat: 'Segueix el teu progrés',
    pt: 'Siga seu progresso'
  },
  SECTION_TRACKING_FILTER_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Haz clic en cada estado para filtrar los temas y llevar un control de tu avance.',
    en: 'Click on each status to filter the topics and keep track of your progress.',
    eus: 'Eztabaidaren informazioa zure konbokoatik lortu.',
    cat: 'Filtra per tema per veure el progrés de cada secció.',
    pt: 'Clique em cada status para filtrar os temas e manter o controle do seu progresso.'
  },
  FAVORITE_LESSONS_TAB_PRODUCT_TOUR_TITLE: {
    es: 'Lecciones favoritas',
    en: 'Favorite lessons',
    eus: 'Ikastetxeko ikasgaiak',
    cat: 'Leccions favorites',
    pt: 'Lições favoritas'
  },
  FAVORITE_LESSONS_TAB_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Accede rápidamente a las lecciones que has marcado como favoritas.',
    en: 'Access your favorite lessons quickly.',
    eus: 'Ikastetxeko ikasgaiak erabili',
    cat: 'Accede ràpidament a les lliçons favorites.',
    pt: 'Acesse rapidamente as lições favoritas.'
  },
  ACTIVITIES_PRODUCT_TOUR_TITLE: {
    es: 'Te presentamos las nuevas actividades',
    en: 'We present you the new activities',
    eus: 'Eraginkizun berriak eskuzituz',
    cat: 'Presentem-teu les noves activitats',
    pt: 'Apresentamos-te as novas atividades'
  },
  ACTIVITIES_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Te traemos cosas nuevas que van a mejorar tu experiencia. ¿Damos un tour rápido para que sepas donde está todo?',
    en: 'We bring you new things that will improve your experience. Do a quick tour so you know where everything is.',
    eus: 'Zure esperientzia hobetuko duten gauza berriak ekartzen dizkizugu. Bisita azkar bat emango al dugu dena non dagoen jakin dezazun?',
    cat: 'Et portem coses noves que milloraran la teva experiència. Donem un tour ràpid perquè sàpigues on és tot?',
    pt: 'Trazemos coisas novas que vão melhorar a sua experiência. Faça um tour rápido para saber onde está tudo?'
  },
  UMY_TAB_PRODUCT_TOUR_TITLE: {
    es: 'Conversación con Umy',
    en: 'Conversation with Umy',
    eus: 'Umyko konbokoatik',
    cat: 'Conversa amb Umy',
    pt: 'Conversa com o Umy'
  },
  UMY_TAB_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Aquí puedes preguntarle a nuestra IA lo que quieras sobre la actividad.',
    en: 'Here you can ask our AI anything about the activity.',
    eus: 'Umyko konbokoatik',
    cat: 'Conversa amb Umy',
    pt: 'Conversa com o Umy'
  },
  QUESTIONS_TAB_PRODUCT_TOUR_TITLE: {
    es: 'Preguntas',
    en: 'Questions',
    eus: 'Galderak',
    cat: 'Preguntes',
    pt: 'Perguntas'
  },
  QUESTIONS_TAB_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Te contestará un profesor y podrás consultarlas aquí y en el apartado de “Dudas”.',
    en: 'Your teacher will answer you and you can consult them here and in the “Questions” section.',
    eus: 'Zure ikastaririk egiaztatu egin duzun eta hemen eta “Egiaztapenak” atalean kontsulta dezakezu.',
    cat: 'El teu professor et contestarà i podràs consultar-les aquí i en la secció de “Preguntes”.',
    pt: 'O seu professor responderá e poderá consultar-las aqui e na secção de “Perguntas”.'
  },
  ACTIVITIES_TAB_PRODUCT_TOUR_TITLE: {
    es: 'Actividades',
    en: 'Activities',
    eus: 'Eraginkizunak',
    cat: 'Activitats',
    pt: 'Atividades'
  },
  ACTIVITIES_TAB_PRODUCT_TOUR_DESCRIPTION: {
    es: 'El índice del curso. Completa, guarda y accede a todas las lecciones desde aquí.',
    en: 'The course index. Complete, save and access all the lessons from here.',
    eus: 'Kursua indexa. Egiaztatu, gordetu eta ikastarak hemen erabili.',
    cat: "Índex del curs. Completa, guarda i accede a totes les lliçons des d'aquí.",
    pt: 'Índice do curso. Complete, guarde e acesse todas as lições a partir daqui.'
  },
  NOTES_TAB_PRODUCT_TOUR_TITLE: {
    es: 'Tu cuaderno',
    en: 'Your notebook',
    eus: 'Zure notabokoa',
    cat: 'El teu quadern',
    pt: 'O seu caderno'
  },
  NOTES_TAB_PRODUCT_TOUR_DESCRIPTION: {
    es: 'Toma notas cuando y donde quieras, y edítalas en cualquier momento.',
    en: 'Take notes as and when you want and edit them at any time.',
    eus: 'Zure notabokoa gordetu eta hemen erabili.',
    cat: "Guarda les teves notes i accede-hi des d'aquí.",
    pt: 'Faça anotações quando e onde quiser e edite-as em qualquer momento.'
  },
  SWIPE_TO_CHANGE_CARD: {
    es: 'Desliza para cambiar de tarjeta',
    en: 'Swipe to change card',
    eus: 'Pasatu hatza txartelak aldatzeko',
    cat: 'Llisca per canviar de targeta',
    pt: 'Deslize para alterar os cartões'
  }
};
